import { render, staticRenderFns } from "./ConsultingService.vue?vue&type=template&id=07b74ae4&scoped=true&"
import script from "./ConsultingService.vue?vue&type=script&lang=ts&"
export * from "./ConsultingService.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultingService.vue?vue&type=style&index=0&id=07b74ae4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b74ae4",
  null
  
)

export default component.exports